var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reporting-main" }, [
    _vm.hasPages
      ? _c(
          "div",
          { staticClass: "reporting-toolbar" },
          [
            _c("ReportingDatePicker", {
              attrs: {
                "date-start": _vm.dateStart,
                "date-end": _vm.dateEnd,
                "compare-mode": _vm.compareMode,
              },
              on: { apply: _vm.onDatePickerApply },
            }),
            _c(
              "button",
              {
                staticClass: "search-btn",
                attrs: { disabled: _vm.loading || !_vm.selectedPageIds.length },
                on: {
                  click: function ($event) {
                    return _vm.loadData(false)
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v(_vm._s(_vm.loading ? "hourglass_empty" : "search")),
                ]),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("dash.reporting.search")) +
                    "\n      "
                ),
              ]
            ),
            _vm.currentStats || _vm.pageStats.length
              ? _c(
                  "button",
                  {
                    staticClass: "refresh-btn",
                    attrs: {
                      disabled: _vm.loading,
                      title: _vm.$t("dash.reporting.force_refresh"),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.loadData(true)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("refresh"),
                    ]),
                  ]
                )
              : _vm._e(),
            (!_vm.isComparisonMode && _vm.currentStats) ||
            (_vm.isComparisonMode && _vm.detailPageId && _vm.detailStats)
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.closeExportDropdown,
                        expression: "closeExportDropdown",
                      },
                    ],
                    staticClass: "export-dropdown",
                    class: { open: _vm.exportDropdownOpen },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "export-btn",
                        attrs: {
                          disabled: _vm.pdfLoading || _vm.apiUrlLoading,
                        },
                        on: {
                          click: function ($event) {
                            _vm.exportDropdownOpen = !_vm.exportDropdownOpen
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v(
                            _vm._s(
                              _vm.pdfLoading || _vm.apiUrlLoading
                                ? "hourglass_empty"
                                : "file_download"
                            )
                          ),
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("dash.reporting.export")) +
                            "\n          "
                        ),
                        _c(
                          "i",
                          { staticClass: "material-icons export-caret" },
                          [_vm._v("expand_more")]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.exportDropdownOpen,
                            expression: "exportDropdownOpen",
                          },
                        ],
                        staticClass: "export-menu",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "export-item",
                            on: {
                              click: function ($event) {
                                return _vm.runExport("pdf")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("picture_as_pdf"),
                            ]),
                            _vm._v(" PDF\n          "),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "export-item",
                            on: {
                              click: function ($event) {
                                return _vm.runExport("csv")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("table_chart"),
                            ]),
                            _vm._v(" CSV\n          "),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "export-item",
                            on: {
                              click: function ($event) {
                                return _vm.runExport("excel")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("grid_on"),
                            ]),
                            _vm._v(" Excel\n          "),
                          ]
                        ),
                        _c("div", { staticClass: "export-separator" }),
                        _c(
                          "button",
                          {
                            staticClass: "export-item",
                            on: {
                              click: function ($event) {
                                return _vm.runExport("api")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("link"),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("dash.reporting.api_url")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "reporting-content" },
      [
        _vm.apiModal.open
          ? _c(
              "div",
              {
                staticClass: "api-modal-backdrop",
                on: {
                  click: function ($event) {
                    if ($event.target !== $event.currentTarget) return null
                    _vm.apiModal.open = false
                  },
                },
              },
              [
                _c("div", { staticClass: "api-modal" }, [
                  _c("div", { staticClass: "api-modal-header" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("dash.reporting.api_url_title"))),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "api-modal-close",
                        on: {
                          click: function ($event) {
                            _vm.apiModal.open = false
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("close"),
                        ]),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "api-modal-body" },
                    [
                      _c("p", { staticClass: "api-modal-desc" }, [
                        _vm._v(_vm._s(_vm.$t("dash.reporting.api_url_desc"))),
                      ]),
                      _vm.apiModal.loading
                        ? _c("div", { staticClass: "api-modal-loading" }, [
                            _c("i", { staticClass: "material-icons spin" }, [
                              _vm._v("hourglass_empty"),
                            ]),
                          ])
                        : _vm.apiModal.url
                        ? [
                            _c("div", { staticClass: "api-url-field" }, [
                              _c("input", {
                                ref: "apiUrlInput",
                                staticClass: "api-url-input",
                                attrs: { type: "text", readonly: "" },
                                domProps: { value: _vm.apiModal.url },
                              }),
                              _c(
                                "button",
                                {
                                  staticClass: "api-url-copy",
                                  attrs: {
                                    title: _vm.$t(
                                      "dash.reporting.api_url_copy"
                                    ),
                                  },
                                  on: { click: _vm.copyApiUrl },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.apiModal.copied
                                          ? "check"
                                          : "content_copy"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _c("p", { staticClass: "api-url-hint" }, [
                              _vm._v(
                                _vm._s(_vm.$t("dash.reporting.api_url_hint"))
                              ),
                            ]),
                          ]
                        : _vm.apiModal.error
                        ? _c("p", { staticClass: "api-modal-error" }, [
                            _vm._v(_vm._s(_vm.apiModal.error)),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm.loading
          ? _c("div", { staticClass: "reporting-progress" }, [
              _c("div", { staticClass: "progress-bar-track" }, [
                _c("div", {
                  staticClass: "progress-bar-fill",
                  style: { width: _vm.progressPercent + "%" },
                }),
              ]),
              _vm.progressDay
                ? _c("span", { staticClass: "progress-label" }, [
                    _vm._v(_vm._s(_vm.progressDay)),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        !_vm.selectedPageIds.length
          ? _c("div", { staticClass: "reporting-empty" }, [
              _c("i", { staticClass: "material-icons" }, [_vm._v("bar_chart")]),
              _c("p", [_vm._v(_vm._s(_vm.$t("dash.reporting.select_page")))]),
            ])
          : _vm.isComparisonMode && _vm.pageStats.length
          ? [
              _c(
                "div",
                { staticClass: "comparison-tab-bar" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "ctab ctab--global",
                      class: { active: !_vm.detailPageId },
                      on: {
                        click: function ($event) {
                          _vm.detailPageId = null
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons ctab-icon" }, [
                        _vm._v("dashboard"),
                      ]),
                      _c("span", { staticClass: "ctab-label" }, [
                        _vm._v(_vm._s(_vm.$t("dash.reporting.comparison"))),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "ctab-sep" }),
                  _vm._l(_vm.pageStats, function (entry) {
                    return _c(
                      "div",
                      {
                        key: entry.page.id,
                        staticClass: "ctab",
                        class: { active: entry.page.id === _vm.detailPageId },
                        on: {
                          click: function ($event) {
                            _vm.detailPageId = entry.page.id
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "ctab-avatar-wrap" }, [
                          entry.page.avatar
                            ? _c("img", {
                                staticClass: "ctab-avatar",
                                attrs: { src: entry.page.avatar, alt: "" },
                              })
                            : _c(
                                "span",
                                { staticClass: "ctab-avatar-fallback" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      (entry.page.name || "?")[0].toUpperCase()
                                    )
                                  ),
                                ]
                              ),
                          _vm.networkIcon(entry.page.network)
                            ? _c("img", {
                                staticClass: "ctab-net-badge",
                                attrs: {
                                  src: _vm.networkIcon(entry.page.network),
                                  alt: "",
                                },
                              })
                            : _vm._e(),
                        ]),
                        _c("span", { staticClass: "ctab-label" }, [
                          _vm._v(_vm._s(entry.page.name)),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
              !_vm.detailPageId
                ? [
                    _c("ReportingComparison", {
                      attrs: {
                        "pages-data": _vm.pageStats,
                        "date-start": _vm.dateStart,
                        "date-end": _vm.dateEnd,
                        "sort-criterion": _vm.comparisonSortCriterion,
                        "concurrent-data": _vm.concurrentDataCache,
                        "prev-loading": _vm.prevLoading,
                        "concurrents-loading": _vm.concurrentsLoading,
                      },
                      on: {
                        "drill-down": function ($event) {
                          _vm.detailPageId = $event
                        },
                      },
                    }),
                    _c("ReportingComparisonAggregate", {
                      attrs: {
                        "pages-data": _vm.pageStats,
                        "prev-loading": _vm.prevLoading,
                        "sort-criterion": _vm.comparisonSortCriterion,
                      },
                      on: {
                        "update:sortCriterion": function ($event) {
                          _vm.comparisonSortCriterion = $event
                        },
                        "update:sort-criterion": function ($event) {
                          _vm.comparisonSortCriterion = $event
                        },
                      },
                    }),
                  ]
                : _vm.detailPageId && _vm.detailStats
                ? [
                    _c("ReportingOverview", {
                      attrs: {
                        stats: _vm.detailStats,
                        page: _vm.detailPage,
                        "date-start": _vm.dateStart,
                        "date-end": _vm.dateEnd,
                        "prev-loading": _vm.prevLoading,
                      },
                    }),
                    _c("ReportingVisibility", {
                      attrs: {
                        stats: _vm.detailStats,
                        "graph-labels": _vm.detailGraphLabels,
                        page: _vm.detailPage,
                      },
                    }),
                    _c("ReportingImpressions", {
                      attrs: {
                        stats: _vm.detailStats,
                        "graph-labels": _vm.detailGraphLabels,
                        page: _vm.detailPage,
                      },
                    }),
                    _c("ReportingEngagement", {
                      attrs: {
                        stats: _vm.detailStats,
                        "graph-labels": _vm.detailGraphLabels,
                        page: _vm.detailPage,
                      },
                    }),
                    _c("ReportingContent", {
                      attrs: { stats: _vm.detailStats, page: _vm.detailPage },
                    }),
                    _c("ReportingPostTypes", {
                      attrs: { stats: _vm.detailStats, page: _vm.detailPage },
                    }),
                    _c("ReportingVideos", {
                      attrs: { stats: _vm.detailStats, page: _vm.detailPage },
                    }),
                    _c("ReportingStories", {
                      attrs: { stats: _vm.detailStats, page: _vm.detailPage },
                    }),
                    _c("ReportingDemographics", {
                      attrs: { stats: _vm.detailStats, page: _vm.detailPage },
                    }),
                    _c("ReportingConcurrent", {
                      ref: "concurrentSection",
                      attrs: {
                        page: _vm.detailPage,
                        stats: _vm.detailStats,
                        "date-start": _vm.dateStart,
                        "date-end": _vm.dateEnd,
                      },
                    }),
                  ]
                : _vm._e(),
            ]
          : !_vm.isComparisonMode && _vm.currentStats
          ? [
              _c("ReportingOverview", {
                attrs: {
                  stats: _vm.currentStats,
                  page: _vm.currentPage,
                  "date-start": _vm.dateStart,
                  "date-end": _vm.dateEnd,
                  "prev-loading": _vm.prevLoading,
                },
              }),
              _c("ReportingVisibility", {
                attrs: {
                  stats: _vm.currentStats,
                  "graph-labels": _vm.graphLabels,
                  page: _vm.currentPage,
                },
              }),
              _c("ReportingImpressions", {
                attrs: {
                  stats: _vm.currentStats,
                  "graph-labels": _vm.graphLabels,
                  page: _vm.currentPage,
                },
              }),
              _c("ReportingEngagement", {
                attrs: {
                  stats: _vm.currentStats,
                  "graph-labels": _vm.graphLabels,
                  page: _vm.currentPage,
                },
              }),
              _c("ReportingContent", {
                attrs: { stats: _vm.currentStats, page: _vm.currentPage },
              }),
              _c("ReportingPostTypes", {
                attrs: { stats: _vm.currentStats, page: _vm.currentPage },
              }),
              _c("ReportingVideos", {
                attrs: { stats: _vm.currentStats, page: _vm.currentPage },
              }),
              _c("ReportingStories", {
                attrs: { stats: _vm.currentStats, page: _vm.currentPage },
              }),
              _c("ReportingDemographics", {
                attrs: { stats: _vm.currentStats, page: _vm.currentPage },
              }),
              _c("ReportingConcurrent", {
                ref: "concurrentSection",
                attrs: {
                  page: _vm.currentPage,
                  stats: _vm.currentStats,
                  "date-start": _vm.dateStart,
                  "date-end": _vm.dateEnd,
                },
              }),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }